<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.currentPlamt()
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
      localStorage.setItem('curEquip', 'm')
    } else {
      localStorage.setItem('curEquip', 'pc')
    }
  },
  methods: {
    currentPlamt() {
      var hrefStr = window.location.href
      let paramStr = ''
      if(hrefStr.indexOf('?')) {
        paramStr = hrefStr.split('=')[1]
      }
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || /(iPhone|iPad|iPod|iOS)/i.test(u) || paramStr == 'apple'; // ios终端
      var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent); // 是否是safari浏览器打开
      if(isAndroid) {
        return localStorage.setItem('curSystem', 'Android')
      } else if(isiOS) {
        return localStorage.setItem('curSystem', 'iOS')
      } else if(issafariBrowser) {
        return localStorage.setItem('curSystem', 'iOS')
      } else {
        return localStorage.setItem('curSystem', 'other')
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: PingFangSC-Semibold, PingFang SC, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #111216;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue